import { FileText, MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateSalesforceCustomFieldsFillUpAr: TemplateAr = {
  name: 'أتمتة تعبئة حقول Salesforce المخصصة بالذكاء الاصطناعي',
  description:
    'عبّئ حقول Salesforce المخصصة تلقائياً أثناء المحادثة، وأعفِ فريق الدعم من الإدخال اليدوي.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'العميل' },
    { icon: Sparkles, label: 'الـ AI يستخرج' },
    { icon: FileText, label: 'الحقول معبّأة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'خلّ حقول Salesforce تتعبّى وأنت مع العميل، مو بعد ما تسكّر الحالة. الـ AI يقرأ المحادثة، ويحدد نقاط البيانات الأساسية، ويحدّث حقول Service Cloud لحظياً. وينتهي الإدخال اليدوي.',
    paragraph2:
      'بيانات الحقول تتزامن مباشرة مع حالات Salesforce، ومعها سجل تدقيق كامل. والنظام يشتغل جنب سير عملك ومُشغّلاتك وقواعد التحقق اللي عندك في Salesforce، ويحترم صلاحيات الحقول وإعداداتك.',
  },
  benefits: [
    'خلّص موظفيك من الإدخال اليدوي',
    'كل حالة تطلع بحقول معبّاة بنفس الطريقة',
    'وقت معالجة الحالة ينزل وتلاحظ الفرق',
    'بيانات Salesforce عندك تطلع أنظف',
    'كل تعبئة لها سجل تدقيق كامل للامتثال',
    'يشتغل مع كل حقول Salesforce المخصصة عندك',
  ],
};
